import { render, staticRenderFns } from "./FusionBanner.vue?vue&type=template&id=38fc041c&scoped=true&"
import script from "./FusionBanner.vue?vue&type=script&lang=js&"
export * from "./FusionBanner.vue?vue&type=script&lang=js&"
import style0 from "./FusionBanner.vue?vue&type=style&index=0&id=38fc041c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fc041c",
  null
  
)

export default component.exports